import React from 'react';
import StatisticsBtnGroup from './StatisticsBtnGroup';
import { observer, inject } from 'mobx-react';
import styles from './StatisticsResource.less';

@inject('statisticsResourceStore')
@observer
class StatisticsResource extends React.Component {
  render() {
    const {
      trafficBtnGroup,
      storageBtnGroup,
      loadTrafficModalData,
      loadStorageModalData
    } = this.props.statisticsResourceStore;

    return (
      <div className={styles.StatisticsResource}>
        <p className={styles.title}>设备资源使用统计</p>
        <StatisticsBtnGroup
          title={'移动流量(月)'}
          btnGroup={trafficBtnGroup}
          handelClick={loadTrafficModalData}
        />
        <StatisticsBtnGroup
          title={'存储占用率'}
          btnGroup={storageBtnGroup}
          handelClick={loadStorageModalData}
        />
      </div>
    );
  }
}
export default StatisticsResource;



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticsResource.js